import { Button, CircularProgress } from "@mui/material";
import React, { useState } from "react";

import { useDispatch } from "react-redux";

import { IMedicalRecordPdf } from "../../../../services/medical-history/medical-history.interface";
import { downloadPdf } from "./downloadPdf";
import { toastMessageActions } from "../../../../state/request";
import { userActivityLogger } from "../../../../utils/mixpanel";

type Props = {
  id: string;
  label: string;
  mixpanelEvent: string;
  petName: string;
  errorMessage: string;
  fetchPdf: () => Promise<IMedicalRecordPdf | null>;
};

const DownloadPdfButton = (props: Props) => {
  const { id, label, mixpanelEvent, petName, errorMessage, fetchPdf } = props;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    if (isLoading) {
      return;
    }

    userActivityLogger(mixpanelEvent, {
      action: "download",
      pet_name: petName,
    });

    setIsLoading(true);
    try {
      const pdf = await fetchPdf();

      if (!pdf?.url) {
        throw new Error("Missing PDF document");
      }

      await downloadPdf(pdf);
    } catch {
      dispatch(
        toastMessageActions.setGlobalAlert({
          message: errorMessage,
          severity: "error",
        }),
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      fullWidth
      type="button"
      id={id}
      className="!normal-case !rounded-full !h-8 geograph-medium !font-bold !text-[12px] !leading-[12px]"
      disabled={isLoading}
      onClick={handleDownload}
      startIcon={
        isLoading ? <CircularProgress size={16} color="inherit" /> : undefined
      }
    >
      {isLoading ? "Preparing…" : label}
    </Button>
  );
};

export default DownloadPdfButton;
